import { MegaraxUri } from "../uri";
import { LegacyRedirect, redirect } from "./redirect";

export const catalogRedirects: LegacyRedirect[] = [
  redirect("/crm/items/new", () => MegaraxUri("megarax://catalog/items")),
  redirect("/crm/items/id/:itemId", ({ itemId }) => MegaraxUri("megarax://catalog/items/id/{id}", { id: itemId })),
  redirect("/crm/items/:itemId", ({ itemId }) => MegaraxUri("megarax://catalog/items/id/{id}", { id: itemId })),
  redirect("/crm/items", () => MegaraxUri("megarax://catalog/items")),
];
